import { createSlice, PayloadAction } from '@reduxjs/toolkit'

/**
 * Só guarda se a Loja está no modo "todos os idiomas" — o idioma concreto em
 * si (quando não é esse modo) já vem de `i18n.language`, que é global e
 * também controla o "Idioma" do drawer de configurações. Ver
 * `useStoreLanguage`: as duas fontes viram uma coisa só, exceto por "todos
 * os idiomas", que só existe pro filtro de conteúdo da Loja (não é um idioma
 * de interface válido). Esse modo é intencionalmente temporário: ao recarregar
 * o app, a Loja volta ao idioma atual do usuário.
 */
type StoreFrontState = {
  browseAllLanguages: boolean
}

const initialState: StoreFrontState = {
  browseAllLanguages: false,
}

const storeFrontSlice = createSlice({
  name: 'storeFront',
  initialState,
  reducers: {
    setBrowseAllLanguages: (state, { payload }: PayloadAction<boolean>) => {
      state.browseAllLanguages = payload
    },
  },
})

export const { setBrowseAllLanguages } = storeFrontSlice.actions
export default storeFrontSlice.reducer
